import React, { useEffect, useState } from 'react';
import useFetch from 'use-http';
import moment from 'moment';
import ReportQueue from 'src/models/ReportQueue';

const RecentReports = () => {
    const { get, response } = useFetch();
    const [recentReports, setRecentReports] = useState<ReportQueue[]>([]);
    const [downloadingId, setDownloadingId] = useState<number>(undefined);

    useEffect(() => {
        loadRecentReports();
    }, []);

    const loadRecentReports = async () => {
        const data: ReportQueue[] = await get(`v1.0/reports/queue/recent?top=10`);
        if (response.ok) {
            setRecentReports(data || []);
        }
    };

    const downloadReport = async (queue: ReportQueue) => {
        if (!queue.s3FileId) { return; }

        setDownloadingId(queue.id);
        await get(`v1.0/s3Bucket/by-id/${queue.s3FileId}`);

        if (response.ok) {
            const baseName = queue.reportTitle || 'report';
            const downloadFileName = /\.[a-z0-9]+$/i.test(baseName) ? baseName : `${baseName}.xlsx`;

            await response.blob().then((blob) => {
                if (blob && blob.size > 0) {
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = downloadFileName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(blobUrl);
                }
            });
        }
        setDownloadingId(undefined);
    };

    if (!recentReports || recentReports.length === 0) {
        return null;
    }

    return (
        <div className="report-group-card recent-reports">
            <div className="title">Recently Run Reports</div>
            <div className="recent-reports-list">
                {recentReports.map((rpt) => (
                    <div key={rpt.id} className="recent-report-row">
                        <div className="recent-report-title">{rpt.reportTitle}</div>
                        <div className="recent-report-date">
                            {rpt.timeCompleted
                                ? moment(rpt.timeCompleted).format('MM-DD-YYYY h:mm A') as unknown as string
                                : ''}
                        </div>
                        <div
                            className={`recent-report-download ${rpt.s3FileId ? 'clickable' : 'disabled'}`}
                            onClick={() => rpt.s3FileId && downloadingId !== rpt.id && downloadReport(rpt)}
                        >
                            {downloadingId === rpt.id ? 'Downloading...' : 'Download'}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RecentReports;



// WEBPACK FOOTER //
// ./src/components/project/sections/ReportComponents/RecentReports.tsx